import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';
import { TooltipModule } from 'primeng/tooltip';
import { DetailDocumentsComponent } from 'src/app/shared/components/detail-documents/detail-documents.component';
import { IrpfTableComponent } from 'src/app/shared/components/irpf-table/irpf-table.component';
import { IrpfTableService } from 'src/app/shared/components/irpf-table/irpf-table.service';
import { DOCUMENT_NAMES_TO_REMOVE } from 'src/app/shared/constants/innovation-documents-constants';
import { InnovationRequestDetailService } from '../innovation-request-detail.service';
import { InnovationKpisComponent } from './innovation-kpis/innovation-kpis.component';

@Component({
    selector: 'app-innovation-request-detail-documents',
    templateUrl: './innovation-request-detail-documents.component.html',
    standalone: true,
    imports: [
        TooltipModule,
        AccordionModule,
        TranslateModule,
        TooltipModule,
        IrpfTableComponent,
        InnovationKpisComponent,
        DetailDocumentsComponent
    ]
})
export class InnovationRequestDetailDocumentsComponent {
    readonly irpfTableService = inject(IrpfTableService);
    readonly innovationRequestDetailService = inject(InnovationRequestDetailService);
    protected documentNamesToRemove = DOCUMENT_NAMES_TO_REMOVE;
}
